import { useEffect, useRef, useState } from "react";

/** Keep fixed dock controls above the footer's Legal block. */
export function useFooterDockOffset(active = true): number {
  const [offset, setOffset] = useState(0);
  const frameRef = useRef(0);

  useEffect(() => {
    if (!active) {
      setOffset(0);
      return;
    }

    const update = () => {
      frameRef.current = 0;
      const footerLegal = document.querySelector<HTMLElement>("[data-footer-legal]");
      const nextOffset = footerLegal ? Math.max(0, window.innerHeight - footerLegal.getBoundingClientRect().top) : 0;
      setOffset((current) => Math.abs(current - nextOffset) < 1 ? current : nextOffset);
    };
    const schedule = () => {
      if (!frameRef.current) frameRef.current = requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    return () => {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    };
  }, [active]);

  return offset;
}
